export const colors = ["#624AFA", "#767BFF", "#44B7FF", "#18A6FF", "#0E92E4"];

export const fontSize = 14;